import styled from "styled-components";

export const Main = styled.main`
  font-family: "Relaway", sans-serif;
  display: flex;
  flex-direction: column;
  section {
    padding: 100px 0;
    border-top: 1px solid rgba(0, 0, 0, 0.1);
    @media screen and (max-width: 768px) {
      padding: 30px 15px;
    }
    .container {
      display: flex;
      margin: 0 auto;
      width: 1280px;
      justify-content: center;
      align-items: center;
      @media screen and (max-width: 768px) {
        flex-direction: column;
        width: 100%;
      }
      .left-container {
        flex: 1;
        margin-right: 25px;
        @media screen and (max-width: 768px) {
          margin-right: 0;
        }
        img {
          width: 100%;
          padding: 5px;
          background: #fff;
          border: 1px solid rgba(0, 0, 0, 0.25);
        }
      }
      .right-container {
        flex: 1;
        justify-content: center;
        align-items: center;
        margin-left: 25px;
        @media screen and (max-width: 768px) {
          margin-left: 0;
          margin-top: 20px;
        }
        .client-name {
          font-weight: 100;
          font-size: 40px;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.9);
          opacity: 0.7;
          line-height: 1em;
          margin-bottom: 10px;
          @media screen and (max-width: 768px) {
            font-size: 37px;
          }
        }
        .client-info {
          font-weight: 400;
          font-size: 25px;
          color: rgba(0, 0, 0, 0.8);
          opacity: 0.7;
          @media screen and (max-width: 768px) {
            font-size: 18px;
          }
        }
        .client-desc {
          color: rgba(0, 0, 0, 0.6);
          padding: 20px 0;
          margin: 20px 0;
          position: relative;
          :after,
          :before {
            content: "";
            position: absolute;
            left: 0;
            width: 50px;
            height: 1px;
            background: #888;
          }
          :after {
            top: 0;
          }
          :before {
            bottom: 0;
          }
        }
        .client-link a {
          color: #1877f2;
          text-decoration: none;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          svg {
            margin-right: 5px;
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/Main/style.js